export const PUBLISHER = 'Publisher';
export const WEBSITE = 'Property';
export const ERROR_CATEGORY = 'Category';
export const PRODUCT = 'Product';
